import adminHttp from "/src/api/adminHttp";

const END_POINT = '/api/admin/timezones';

export default {
    /**
     * GET: Games
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    index: () => adminHttp.get(END_POINT),
}